import { captureMessage } from '@sentry/react';

export interface CdmTemplateServiceUtilsContextInterface {
  captureMessage: typeof captureMessage;
}

export const cdmTemplateServiceUtilsContext: CdmTemplateServiceUtilsContextInterface =
  {
    captureMessage,
  };
